$(document).ready(function () {
  $.validator.addMethod(
    "emailValidDomain",
    function (value) {
      const s = value.trim().toLowerCase();
      return s.match(
        /[a-zA-Z0-9!#\$%&'*+\/=?\^_`{|}~\-]+(?:\.[a-zA-Z0-9!#\$%&'\*+\/=?\^_`{|}~\-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9]{2,}(?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$/
      );
    },
    "Please enter a valid email address."
  );

  $.validator.addMethod(
    "validDomain",
    function (value) {
      const s = value.trim().toLowerCase();
      if (s.indexOf("http://") > -1 || s.indexOf("https://") > -1) {
        return false;
      }
      return s.match(/^((?!-)[A-Za-z0-9-]{1,63}(?<!-)\.)+[A-Za-z]{2,6}$/);
    },
    "Please enter a valid domain."
  );

  $.validator.addMethod(
    "otherForumRequiredIfOther",
    function (value) {
      const s = value.trim().toLowerCase();
      return (
        ($currentForumInput.val() === "other" && s.length > 0) ||
        $currentForumInput.val() !== "other"
      );
    },
    "Please enter a value or choose another option."
  );

  $.validator.addMethod(
    "otherPrimaryGoalRequiredIfOther",
    function (value) {
      const s = value.trim().toLowerCase();
      return (
        ($migrationGoalsOtherCheckbox.is(":checked") && s.length > 0) ||
        !$migrationGoalsOtherCheckbox.is(":checked")
      );
    },
    "Please enter a value."
  );

  const $migrationForm = $("#migration-form"),
    $currentForumInput = $("#current_forum"),
    $currentForumFields = $("#current-forum-fields"),
    $migrationGoalsOtherCheckbox = $("#migration_goals_other_checkbox"),
    $migrationGoalsFields = $("#migration_goals_fields"),
    $emailOptInCheckbox = $("#email_opt_in"),
    $nameField = $("#full_name"),
    $errorNotice = $("#error-notice"),
    $formSubmit = $("#submit-migration", $migrationForm);

  const urlParams = new URLSearchParams(window.location.search);
  const language = urlParams.get("l") ?? "en";

  $nameField.focus();

  $migrationForm.validate({
    ignore: ":hidden",
    rules: {
      email: {
        required: true,
        email: true,
        emailValidDomain: true,
      },
      full_name: {
        required: true,
      },
      company_name: {
        required: true,
      },
      domain: {
        required: true,
        validDomain: true,
      },
      current_forum: {
        required: true,
      },
      current_forum_other: {
        required: false,
        otherForumRequiredIfOther: true,
      },
      migrate_users: {
        required: true,
      },
      migrate_posts: {
        required: true,
      },
      migration_goals_other: {
        required: false,
        otherPrimaryGoalRequiredIfOther: true,
      },
      launch_estimate: {
        required: true,
      },
    },
    errorPlacement: function (error, element) {
      if (element.attr("name") === "domain") {
        error.insertAfter("#discourse-group-inputs");
      } else {
        error.insertAfter(element);
      }
    },
  });

  $currentForumInput.on("change", function () {
    if ($currentForumInput.val() !== "other") {
      $(".has-current-forum", $migrationForm).slideUp();
    } else {
      $currentForumFields.slideDown();
    }
  });

  $migrationGoalsOtherCheckbox.on("change", function () {
    if ($migrationGoalsOtherCheckbox.is(":checked")) {
      $migrationGoalsFields.slideDown();
    } else {
      $(".migration_goals_other", $migrationForm).slideUp();
    }
  });

  $currentForumInput.change();
  $migrationGoalsOtherCheckbox.change();

  let formSubmitted = false;

  $migrationForm.on("submit", function (e) {
    const tier = $("#tier_selected").val();
    if (!formSubmitted && $migrationForm.valid()) {
      $formSubmit.addClass("invisible");
      formSubmitted = true;

      if ($errorNotice) {
        $errorNotice.html("");
        $errorNotice.hide();
      }

      const formData = {
        email_opt_in: $emailOptInCheckbox.is(":checked"),
        migration_goals: $("input[name='migration_goals[]']:checked")
          .map(function () {
            return this.value;
          })
          .get()
          .join(", "),
      };

      $.each($migrationForm.serializeArray(), function (i, field) {
        if (["email_opt_in", "migration_goals[]"].indexOf(field.name) < 0) {
          formData[field.name] = field.value;
        }
      });

      $.ajax({
        url: window.MIGRATIONS_API_URL,
        type: "POST",
        dataType: "json",
        data: formData,
      })
        .done(function (response) {
          if (response.success) {
            window.location.href = `/migrations/confirm?tier=b&language=${language}`;
            // Plausible conversion event tracking is defined globally in <head/>
            // eslint-disable-next-line no-undef
            plausible("Migration Request Conversion", {
              props: { tier, language },
            });
          } else {
            $errorNotice.html(response.messages.join("<br/>"));
            $errorNotice.show();
          }
        })
        .fail(function (xhr) {
          if (xhr.status === 429) {
            $errorNotice.html(
              "Too many requests. Please wait and try again later."
            );
          } else {
            $errorNotice.html(
              "Sorry, something went wrong. Try again or send an email to <a href='mailto:team@discourse.org'>team@discourse.org</a>."
            );
          }
          $errorNotice.show();
        })
        .always(function () {
          formSubmitted = false;
          $formSubmit.removeClass("invisible");
        });
    }
    e.preventDefault();
    return false;
  });
});
